import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AdminForm from "../../AdminForm";
import { addVideo } from "../videosAdminSlice";

const fields = {
  title: "Информация",
  data: [
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Текст",
      name: "title",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Линк",
      name: "link",
    },
    {
      required: true,
      options: undefined,
      type: "boolean",
      title: "Активен",
      name: "is_active",
    },
  ],
};

const AddVideo = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    dispatch(
      addVideo(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <AdminForm
      formTitle="Добавяне на видео"
      onSubmit={onSubmit}
      field={fields}
      progress={progress}
    />
  );
};

export default AddVideo;
